{"schemaVersion":1,"release":{"version":"1.0.6","build":141,"url":"https://cdn.gab.ai/macos/updates/installers/Gab-AI-1.0.6-141.dmg","sha256":"6ac0c6b58d87d4dcbff182e698d8eb279f8324521c5d70e296335c31e8388435","size":28733973}}
